var _G, _G2, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path, Defs, LinearGradient, Stop } from "react-native-svg";
var SvgFriends = function SvgFriends(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    fill: "#783300"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M13.502 16.877a5.625 5.625 0 1 0 0-11.25 5.625 5.625 0 0 0 0 11.25"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M3.377 32.627v-6.75c0-9.563 20.25-9.563 20.25 0v6.75zM26.44 16.314a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M24.752 32.627v-7.313c0-3.937-1.125-5.625-2.25-6.75 6.187-2.25 11.812 1.688 11.812 6.188v7.875z"
  }))), _G2 || (_G2 = /*#__PURE__*/React.createElement(G, {
    stroke: "#FFE597",
    strokeWidth: 0.45
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "url(#friends_svg__a)",
    d: "M10.35 11.475a5.625 5.625 0 1 0 0-11.25 5.625 5.625 0 0 0 0 11.25Z",
    transform: "translate(2.586 3.714)"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: "url(#friends_svg__b)",
    d: "M.225 26.663v-6.188c0-9 20.25-9 20.25 0v6.188z",
    transform: "translate(2.586 3.714)"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: "url(#friends_svg__c)",
    d: "M23.288 10.913a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z",
    transform: "translate(2.586 3.714)"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: "url(#friends_svg__d)",
    d: "M21.6 26.662v-6.187c0-3.938-1.125-5.625-2.25-6.75 6.188-2.25 11.813 1.125 11.813 5.625v7.312z",
    transform: "translate(2.586 3.714)"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "friends_svg__a",
    x1: 4.725,
    x2: 8.1,
    y1: 0.225,
    y2: 11.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FFF8BD"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.38,
    stopColor: "#FFE16A"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.62,
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#B86700"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "friends_svg__b",
    x1: 0.225,
    x2: 2.832,
    y1: 13.725,
    y2: 27.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FFF8BD"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.38,
    stopColor: "#FFE16A"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.62,
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#B86700"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "friends_svg__c",
    x1: 18.788,
    x2: 21.488,
    y1: 1.913,
    y2: 10.912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FFF8BD"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.38,
    stopColor: "#FFE16A"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.62,
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#B86700"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "friends_svg__d",
    x1: 19.35,
    x2: 23.957,
    y1: 13.009,
    y2: 26.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FFF8BD"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.38,
    stopColor: "#FFE16A"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.62,
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#B86700"
  })))));
};
export default SvgFriends;